import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { LAYOUT } from '@/theme';

export function AppFooter() {
  return (
    <Box component="footer" sx={{ px: { xs: 2, md: 4 }, pb: 3, width: '100%', maxWidth: LAYOUT.contentMaxWidth, mx: 'auto' }}>
      <Typography variant="caption" component="p" sx={{ color: 'text.disabled', borderTop: 1, borderColor: 'divider', pt: 2 }}>
        AI Planet, prepared for OCBC. Demo built on public OCBC Global Markets Research only.
      </Typography>
    </Box>
  );
}
